import { GameId } from '@bg-shared/enums';
import { ClassicGameDefinition } from './ClassicGameDefinition';
import { EuroRouletteDefinition } from './EuroRouletteDefinition';
import { AmericanRouletteDefinition } from './AmericanRouletteDefinition';

export const getRouletteDefinition = (gameId: GameId) =>
    ClassicGameDefinition.isEuroRoulette(gameId)
        ? EuroRouletteDefinition
        : AmericanRouletteDefinition;
